module.exports = __webpack_public_path__ + "static/img/pro11_tab2.4821b98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro11_tab2.jpg
// module id = ZOXf
// module chunks = 171